var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 58,
    viewBox: "0 0 73 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73 44.653c-2.318.557-4.878.86-7.696.86h-.608c-18.435 0-25.826-12.98-26.609-25.117a20.683 20.683 0 01-.087-1.64c.022-.27.033-.542.044-.82.01-.265.022-.536.043-.818.391-6.072 2.437-12.355 6.691-17.118H68a5 5 0 015 5v39.653z",
    fill: "#88D6AD",
    fillOpacity: 0.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dHouseContracts)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.28 23.44H34.44v13.68h33.84V23.44z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 24.16l3.699-14.4h29.54L69 24.16H33z",
    fill: "#88D6AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.36 11.2h-18v7.92h18V11.2z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.704 4l-2.784 8.64H61.8L60.155 4H43.704z",
    fill: "#88D6AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.524 26.642H46.26v9.755h5.264v-9.755zm8.266.552h-2.567v2.53h2.567v-2.53zm3.437 0H60.66v2.53h2.567v-2.53zm-3.437 3.451h-2.567v2.623h2.567v-2.623zm3.437 0H60.66v2.623h2.567v-2.623zM54.759 13.22H52.75v1.98h2.009v-1.98zm2.691 0h-2.009v1.98h2.01v-1.98zm-2.691 2.7H52.75v2.053h2.009v-2.052zm2.691 0h-2.009v2.053h2.01v-2.052zm-10.173-2.7h-2.01v1.98h2.01v-1.98zm2.689 0h-2.009v1.98h2.009v-1.98zm-2.689 2.7h-2.01v2.053h2.01v-2.052zm2.689 0h-2.009v2.053h2.009v-2.052z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.699 27.63h-1.265v1.247h1.265v-1.248zm1.695 0h-1.265v1.247h1.265v-1.248zm-1.695 1.7h-1.265v1.293h1.265V29.33zm1.695 0h-1.265v1.293h1.265V29.33zm.434 3.247a.358.358 0 00.349-.368.359.359 0 00-.349-.368.359.359 0 00-.348.368c0 .204.156.368.349.368z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dHouseContracts",
    x: 32,
    y: 4,
    width: 38,
    height: 35.12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.5267149f45562126be3538c1874705d0.svg";
export { ForwardRef as ReactComponent };